import React, { useEffect, useMemo, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import { Editor } from "@tinymce/tinymce-react";
import InputMask from "react-input-mask";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Tooltip,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Alert,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";

import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { wrap } from "lodash";
function NewModel({
  backUrl,
  api,
  getType,
  getOrientation,
  getCategory,
  handleSubmit,
  getShow,
  showData,
  getListe,
  listeData,

  //render

  renderOuiNonOptions,
  renderOrientationOptions,
  renderTypeOptions,
  renderCategorieOptions,
  //Variable
  //actif
  selectedActif,
  handleActifChange,
  // typeDocument
  selectedType,
  handleTypeChange,
  // Nom modele
  selectedNomMod,
  handleNomModChange,
  // original
  selectedOriginal,
  handleOriginalChange,
  // fisc
  selectedFisc,
  handleFiscChange,
  // Transmission API
  selectedTransmissionAPI,
  handleTransmissionAPIChange,
  //Catégorie PME
  selectedCategorie,
  handleCategorieChange,
  // Balises
  selectedBalise,
  handleBaliseChange,
  // Cumul
  selectedCumul,
  handleCumulChange,
  // Commentaire
  selectedCommentaire,
  handleCommentaireChange,
  //Champs
  selectedChamps1,
  selectedChamps2,
  selectedChamps3,
  selectedChamps4,
  selectedChamps5,
  selectedChamps6,
  handleChamps1Change,
  handleChamps2Change,
  handleChamps3Change,
  handleChamps4Change,
  handleChamps5Change,
  handleChamps6Change,
  // Images
  selectedImage1,
  selectedImage2,
  selectedImage3,
  selectedImage4,

  handleImage1Change,
  handleImage2Change,
  handleImage3Change,
  handleImage4Change,
  //Nom du fichier global
  selectedNomGlobal,
  handleNomGlobalChange,
  //Nom Fichier Individuel
  selectedNomIndividuel,
  handleNomIndividuelChange,
  //un fichier par occurence
  selectedFichierParOccurence,
  handleFichierParOccurenceChange,
  // Orientation
  selectedOrientation,
  handleOrientationChange,
  // Marge Haut
  selectedMargeHaut,
  handleMargeHautChange,
  // Marge Bas
  selectedMargeBas,
  handleMargeBasChange,
  // Marge Cote
  selectedMargeCote,
  handleMargeCoteChange,
  // Hauteur de ligne
  selectedHauteurLigne,
  handleHauteurLigneChange,
  // Hauteur  pied
  selectedHauteurPied,
  handleHauteurPiedChange,
  //Largeur
  selectedLargeur,
  handleLargeurChange,
  //Tableau
  formSignature,
  onAddFormSignature,
  onDeleteFormSignature,
  handleInputChange,
  // variable données
  // COntenu
  selectedContent,
  handleContentChange,
  selectedHeader,
  handleHeaderChange,
  selectedFooter,
  handleFooterChange,

  // custom
  CustomNavTabs,
  activeTab,
  Titre,
  TitrePage,
  colStyle,
  toggleTooltip,
  tooltipOpen,
  toggleTooltip1,
  tooltipOpen1,
  toggleTooltip2,
  tooltipOpen2,
  toggleTooltip3,
  tooltipOpen3,
  toggleTooltip4,
  tooltipOpen4,
  toggleTooltip5,
  tooltipOpen5,
  toggleTooltip6,
  tooltipOpen6,
  toggleTooltip7,
  tooltipOpen7,
  toggleTooltip8,
  tooltipOpen8,
  toggleTooltip9,
  tooltipOpen9,
  toggleTooltip10,
  tooltipOpen10,
}) {
  const { id } = useParams();
  const apiB = Config.backOffice.apiName;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      handleContentChange(editorRef.current.getContent());
    }
  };
  const token = localStorage.getItem("auth_token_" + apiB);

  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleOffcanvasToggle = () => {
    setShowOffcanvas(!showOffcanvas);
    document.body.classList.toggle("offcanvas-open");
  };

  const [helper, setHelper] = useState("");

  const getHelper = async () => {
    try {
      fetch(`https://www.fluxod.com/${apiB}/publipostages/helpers`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setHelper(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (!loading) {
      getType();
      getOrientation();
      getCategory();
      getListe();
      getHelper();
    }
  }, [loading]);
  useEffect(() => {
    getShow();
  }, [selectedType]);

  const layout = localStorage.getItem("layoutMode");
  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Offcanvas
              isOpen={showOffcanvas}
              scrollable
              backdrop={false}
              toggle={handleOffcanvasToggle}
              style={{ width: "35%" }}
            >
              <OffcanvasHeader toggle={handleOffcanvasToggle}>
                Liste des balises
              </OffcanvasHeader>
              <OffcanvasBody>
                <div dangerouslySetInnerHTML={{ __html: listeData }} />
              </OffcanvasBody>
            </Offcanvas>
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/${api}/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          {TitrePage}
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i> Nouveau
                      </h5>
                    </div>
                    <Alert color="warning" isOpen={true}>
                      <div className="d-flex align-items-center">
                        <i className="mdi mdi-alert-outline"></i>
                        <span>
                          <strong>
                            Astuce : Pour importer un document Word :
                          </strong>
                          <ul className="mb-0 mt-1">
                            <li>
                              Sauvegardez le au format "Web Page Filtered"
                              (HTML)
                            </li>
                            <li>
                              Ouvrez le avec un éditeur de texte type Bloc Note
                            </li>
                            <li>Copiez le contenu dans le presse papier</li>
                            <li>
                              Collez le dans le modèle Fluxod au format HTML
                              (Bouton HTML dans la barre de menu de l'éditeur)
                            </li>
                          </ul>
                        </span>
                      </div>
                    </Alert>
                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Créer
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Caractéristiques
                                  </CardTitle>
                                  <CardBody>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Document type* :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedType}
                                          onChange={handleTypeChange}
                                          options={renderTypeOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(selectedType === null)}
                                        />
                                        {selectedType === null && (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Document type ne peut pas être vide
                                          </div>
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Nom du modèle* :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedNomMod}
                                          required
                                          onChange={handleNomModChange}
                                        />
                                        {selectedNomMod === "" && (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Nom du modèle ne peut pas être vide
                                          </div>
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Original :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedOriginal}
                                          onChange={handleOriginalChange}
                                          options={renderOuiNonOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(false)}
                                        />
                                      </Col>
                                    </Row>

                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Actif* :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          value={selectedActif}
                                          onChange={handleActifChange}
                                          options={renderOuiNonOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(
                                            selectedActif === null
                                          )}
                                        />
                                        {selectedActif === null && (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Actif ne peut pas être vide
                                          </div>
                                        )}
                                      </Col>
                                    </Row>
                                    {showData ? (
                                      <Row className="mb-3">
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i style={{ color: "#9d9c9c" }}>
                                            <span>A transmettre au fisc :</span>
                                          </i>
                                        </Col>
                                        <Col className="col-md-6">
                                          <Select
                                            defaultValue={selectedFisc}
                                            onChange={handleFiscChange}
                                            options={renderOuiNonOptions()}
                                            isClearable={true}
                                            className="select2"
                                            styles={styles(false)}
                                          />
                                        </Col>
                                      </Row>
                                    ) : null}

                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Transmission API CGP :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedTransmissionAPI}
                                          onChange={handleTransmissionAPIChange}
                                          options={renderOuiNonOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(false)}
                                        />
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Filtres / Cumul
                                  </CardTitle>
                                  <CardBody>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Catégorie de PME :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedCategorie}
                                          onChange={handleCategorieChange}
                                          options={renderCategorieOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(false)}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>
                                            Balises non nulle pour impression{" "}
                                            <i
                                              className="bx bx-info-circle"
                                              style={{
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                                color: "black",
                                                fontSize: "15px",
                                              }}
                                              id="Balise"
                                              onMouseEnter={toggleTooltip2}
                                              onMouseLeave={toggleTooltip2}
                                            />
                                            <Tooltip
                                              placement="top"
                                              isOpen={tooltipOpen2}
                                              target="Balise"
                                              toggle={toggleTooltip2}
                                            >
                                              {
                                                helper?.message?.helpers[
                                                  "Balises non nulle pour impression"
                                                ]
                                              }
                                            </Tooltip>{" "}
                                            :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedBalise}
                                          required
                                          onChange={handleBaliseChange}
                                        />
                                      </Col>
                                    </Row>

                                    {api == "publipostages_souscriptions" ? (
                                      <Row className="mb-3">
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i style={{ color: "#9d9c9c" }}>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "11em",
                                                paddingTop: "10px",
                                                color: "#7f7f7f",
                                              }}
                                            >
                                              Cumul par investisseur* :
                                            </span>
                                          </i>
                                        </Col>
                                        <Col className="col-md-6">
                                          <Select
                                            defaultValue={selectedCumul}
                                            onChange={handleCumulChange}
                                            options={renderOuiNonOptions()}
                                            isClearable={true}
                                            className="select2"
                                            styles={styles(
                                              selectedCumul === null
                                            )}
                                          />
                                          {selectedCumul === null && (
                                            <div
                                              style={{
                                                color: "red",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              Cumul par investisseur ne peut pas
                                              être vide
                                            </div>
                                          )}
                                        </Col>
                                      </Row>
                                    ) : null}
                                  </CardBody>
                                </Card>
                                <Row>
                                  <Col sm="12">
                                    <Card className="mb-4">
                                      <CardTitle
                                        tag="h5"
                                        style={{ paddingLeft: "10px" }}
                                      >
                                        Commentaires
                                      </CardTitle>
                                      <CardBody>
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Commentaires :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedCommentaire}
                                              required
                                              onChange={handleCommentaireChange}
                                            />
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Présentation / sortie
                                  </CardTitle>
                                  <CardBody>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Nom du fichier global*:</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedNomGlobal}
                                          required
                                          onChange={handleNomGlobalChange}
                                        />
                                        {selectedNomGlobal === "" && (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Nom du fichier global ne peut pas
                                            être vide
                                          </div>
                                        )}
                                      </Col>
                                    </Row>

                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>
                                            Nom des fichiers individuels*
                                            <i
                                              className="bx bx-info-circle"
                                              style={{
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                                color: "black",
                                                fontSize: "15px",
                                              }}
                                              id="nomFichierIndivInfoTooltip"
                                              onMouseEnter={toggleTooltip}
                                              onMouseLeave={toggleTooltip}
                                            />
                                            <Tooltip
                                              placement="top"
                                              isOpen={tooltipOpen}
                                              target="nomFichierIndivInfoTooltip"
                                              toggle={toggleTooltip}
                                            >
                                              {
                                                helper?.message?.helpers[
                                                  "Nom du fichier"
                                                ]
                                              }
                                            </Tooltip>{" "}
                                            :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedNomIndividuel}
                                          required
                                          onChange={handleNomIndividuelChange}
                                        />
                                        {selectedNomIndividuel === "" && (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Nom des fichiers individuels ne peut
                                            pas être vide
                                          </div>
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>
                                            Un fichier par occurence* :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={
                                            selectedFichierParOccurence
                                          }
                                          onChange={
                                            handleFichierParOccurenceChange
                                          }
                                          options={renderOuiNonOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(
                                            selectedFichierParOccurence === null
                                          )}
                                        />
                                        {selectedFichierParOccurence ===
                                        null ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Un fichier par occurence ne peut pas
                                            être vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Orientation*:</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedOrientation}
                                          onChange={handleOrientationChange}
                                          options={renderOrientationOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(
                                            selectedOrientation === null
                                          )}
                                        />
                                        {selectedOrientation === "" && (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Orientation ne peut pas être vide
                                          </div>
                                        )}
                                      </Col>
                                    </Row>

                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Marge haut (cm)* :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedMargeHaut}
                                          required
                                          onChange={handleMargeHautChange}
                                        />
                                        {selectedMargeHaut === "" && (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Marge haut ne peut pas être vide
                                          </div>
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Marge bas (cm)* :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedMargeBas}
                                          required
                                          onChange={handleMargeBasChange}
                                        />
                                        {selectedMargeBas === "" && (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Marge bas ne peut pas être vide
                                          </div>
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Marge côtés (cm)* :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedMargeCote}
                                          required
                                          onChange={handleMargeCoteChange}
                                        />
                                        {selectedMargeCote === "" && (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Marge côtés ne peut pas être vide
                                          </div>
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>
                                            Hauteur de ligne (em)*{" "}
                                            <i
                                              className="bx bx-info-circle"
                                              style={{
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                                color: "black",
                                                fontSize: "15px",
                                              }}
                                              id="HauteurLigne"
                                              onMouseEnter={toggleTooltip4}
                                              onMouseLeave={toggleTooltip4}
                                            />
                                            <Tooltip
                                              placement="top"
                                              isOpen={tooltipOpen4}
                                              target="HauteurLigne"
                                              toggle={toggleTooltip4}
                                            >
                                              {
                                                helper?.message?.helpers[
                                                  "Hauteur de ligne (em)"
                                                ]
                                              }
                                            </Tooltip>
                                            :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedHauteurLigne}
                                          required
                                          onChange={handleHauteurLigneChange}
                                        />
                                        {selectedHauteurLigne === "" && (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Hauteur de ligne ne peut pas être
                                            vide
                                          </div>
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Largeur (px) :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedLargeur}
                                          required
                                          onChange={handleLargeurChange}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>
                                            Espace entre le footer/header et le
                                            corps :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedHauteurPied}
                                          required
                                          onChange={handleHauteurPiedChange}
                                        />
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                              <Col sm="6">
                                <Row>
                                  <Col sm="12">
                                    <Card className="mb-4">
                                      <CardTitle
                                        tag="h5"
                                        style={{ paddingLeft: "10px" }}
                                      >
                                        Champs d'impression
                                      </CardTitle>
                                      <CardBody>
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Champ 1{" "}
                                                <i
                                                  className="bx bx-info-circle"
                                                  style={{
                                                    marginLeft: "5px",
                                                    fontSize: "15px",
                                                    cursor: "pointer",
                                                    color: "black",
                                                    fontSize: "15px",
                                                  }}
                                                  id="champ1ToolTip"
                                                  onMouseEnter={toggleTooltip1}
                                                  onMouseLeave={toggleTooltip1}
                                                />
                                                <Tooltip
                                                  placement="top"
                                                  isOpen={tooltipOpen1}
                                                  target="champ1ToolTip"
                                                  toggle={toggleTooltip1}
                                                >
                                                  {
                                                    helper?.message?.helpers[
                                                      "Champ 1"
                                                    ]
                                                  }
                                                </Tooltip>{" "}
                                                :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedChamps1}
                                              required
                                              onChange={handleChamps1Change}
                                            />
                                          </Col>
                                        </Row>

                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Champ 2 :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedChamps2}
                                              required
                                              onChange={handleChamps2Change}
                                            />
                                          </Col>
                                        </Row>

                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Champ 3 :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedChamps3}
                                              required
                                              onChange={handleChamps3Change}
                                            />
                                          </Col>
                                        </Row>
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Champ 4 :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedChamps4}
                                              required
                                              onChange={handleChamps4Change}
                                            />
                                          </Col>
                                        </Row>

                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Champ 5 :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedChamps5}
                                              required
                                              onChange={handleChamps5Change}
                                            />
                                          </Col>
                                        </Row>

                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Champ 6 :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedChamps6}
                                              required
                                              onChange={handleChamps6Change}
                                            />
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col sm="12">
                                    <Card className="mb-4">
                                      <CardTitle
                                        tag="h5"
                                        style={{ paddingLeft: "10px" }}
                                      >
                                        Images
                                      </CardTitle>
                                      <CardBody>
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Image 1{" "}
                                                <i
                                                  className="bx bx-info-circle"
                                                  style={{
                                                    marginLeft: "5px",
                                                    cursor: "pointer",
                                                    color: "black",
                                                    fontSize: "15px",
                                                  }}
                                                  id="Image"
                                                  onMouseEnter={toggleTooltip3}
                                                  onMouseLeave={toggleTooltip3}
                                                />
                                                <Tooltip
                                                  placement="top"
                                                  isOpen={tooltipOpen3}
                                                  target="Image"
                                                  toggle={toggleTooltip3}
                                                >
                                                  {
                                                    helper?.message?.helpers[
                                                      "Image 1"
                                                    ]
                                                  }
                                                </Tooltip>
                                                :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              type="file"
                                              onChange={(e) =>
                                                handleImage1Change(e)
                                              }
                                            />
                                          </Col>
                                        </Row>
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Image 2 :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              type="file"
                                              onChange={(e) =>
                                                handleImage2Change(e)
                                              }
                                            />
                                          </Col>
                                        </Row>
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Image 3 :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              type="file"
                                              onChange={(e) =>
                                                handleImage3Change(e)
                                              }
                                            />
                                          </Col>
                                        </Row>
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Image 4 :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              type="file"
                                              onChange={(e) =>
                                                handleImage4Change(e)
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Row>
                                <Col sm="12">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingBottom: "10px" }}
                                  >
                                    Contenu
                                  </CardTitle>
                                  <Row className="mb-3">
                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={4}
                                      // style={colStyle}
                                    >
                                      <i style={{ color: "#9d9c9c" }}>
                                        <span>Liste des balises :</span>
                                      </i>{" "}
                                      <Button onClick={handleOffcanvasToggle}>
                                        Liste
                                      </Button>
                                    </Col>
                                  </Row>
                                  <CardBody>
                                    <div
                                      style={{
                                        textAlign: "center",
                                        paddingBottom: 10,
                                      }}
                                    >
                                      {/* <button
                                        className="btn btn-sm btn-primary"
                                        onClick={log}
                                      >
                                        Enregister
                                      </button> */}
                                    </div>
                                    <Editor
                                      apiKey="qtpzuvciq1zhh5k87yw2b2hoie40flpoqkafr142u8lfhp6i"
                                      onInit={(evt, editor) =>
                                        (editorRef.current = editor)
                                      }
                                      value={selectedContent}
                                      init={{
                                        height: 700,
                                        menubar: true,
                                        plugins: [
                                          "advlist",
                                          "autolink",
                                          "lists",
                                          "link",
                                          "image",
                                          "charmap",
                                          "preview",
                                          "anchor",
                                          "searchreplace",
                                          "visualblocks",
                                          "code",
                                          "fullscreen",
                                          "insertdatetime",
                                          "media",
                                          "table",
                                          "code",
                                          "help",
                                          "wordcount",
                                          "autosave",
                                        ],
                                        toolbar:
                                          "undo redo | blocks | " +
                                          "bold italic forecolor | alignleft aligncenter " +
                                          "alignright alignjustify | bullist numlist outdent indent | " +
                                          "removeformat | help",
                                        content_style:
                                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                      }}
                                      onEditorChange={(content) => {
                                        handleContentChange(content);
                                      }}
                                    />

                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={4}
                                      style={colStyle}
                                    >
                                      <i
                                        style={{
                                          color: "#9d9c9c",
                                        }}
                                      >
                                        <span
                                          style={{
                                            display: "inline-block",
                                            width: "11em",
                                            paddingTop: "10px",
                                          }}
                                        >
                                          Header :
                                        </span>
                                      </i>
                                    </Col>
                                    <Col className="col-md-6">
                                      <textarea
                                        className="form-control form-control-sm"
                                        type="text"
                                        defaultValue={selectedHeader}
                                        required
                                        onChange={handleHeaderChange}
                                      />
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={4}
                                      style={colStyle}
                                    >
                                      <i
                                        style={{
                                          color: "#9d9c9c",
                                        }}
                                      >
                                        <span
                                          style={{
                                            display: "inline-block",
                                            width: "11em",
                                            paddingTop: "10px",
                                          }}
                                        >
                                          Footer :
                                        </span>
                                      </i>
                                    </Col>
                                    <Col className="col-md-6">
                                      <textarea
                                        className="form-control form-control-sm"
                                        type="text"
                                        defaultValue={selectedFooter}
                                        required
                                        onChange={handleFooterChange}
                                      />
                                    </Col>
                                  </CardBody>
                                </Col>
                              </Row>
                              <Col sm="12">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingBottom: "10px" }}
                                >
                                  Signature électronique
                                </CardTitle>
                                <div className="table-responsive">
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th
                                          className="text-nowrap"
                                          style={tableaustyles}
                                        >
                                          Page signature
                                          <i
                                            className="bx bx-info-circle"
                                            style={{
                                              marginLeft: "5px",
                                              cursor: "pointer",
                                              color: "black",
                                              fontSize: "15px",
                                            }}
                                            id={"Page-Signature"}
                                            onMouseEnter={toggleTooltip5}
                                            onMouseLeave={toggleTooltip5}
                                          />
                                          <Tooltip
                                            placement="top"
                                            isOpen={tooltipOpen5}
                                            target={"Page-Signature"}
                                            toggle={toggleTooltip5}
                                          >
                                            {
                                              helper?.message?.helpers[
                                                "Signataires"
                                              ]
                                            }
                                          </Tooltip>
                                        </th>
                                        <th
                                          className="text-nowrap"
                                          style={tableaustyles}
                                        >
                                          Position signature
                                          <i
                                            className="bx bx-info-circle"
                                            style={{
                                              marginLeft: "5px",
                                              cursor: "pointer",
                                              color: "black",
                                              fontSize: "15px",
                                            }}
                                            id={"Position-Signature"}
                                            onMouseEnter={toggleTooltip6}
                                            onMouseLeave={toggleTooltip6}
                                          />
                                          <Tooltip
                                            placement="top"
                                            isOpen={tooltipOpen6}
                                            target={"Position-Signature"}
                                            toggle={toggleTooltip6}
                                          >
                                            {
                                              helper?.message?.helpers[
                                                "Position signature"
                                              ]
                                            }
                                          </Tooltip>
                                        </th>
                                        <th
                                          className="text-nowrap"
                                          style={tableaustyles}
                                        >
                                          Signataire
                                          <i
                                            className="bx bx-info-circle"
                                            style={{
                                              marginLeft: "5px",
                                              cursor: "pointer",
                                              color: "black",
                                              fontSize: "15px",
                                            }}
                                            id={"Signataire"}
                                            onMouseEnter={toggleTooltip7}
                                            onMouseLeave={toggleTooltip7}
                                          />
                                          <Tooltip
                                            placement="top"
                                            isOpen={tooltipOpen7}
                                            target={"Signataire"}
                                            toggle={toggleTooltip7}
                                          >
                                            {
                                              helper?.message?.helpers[
                                                "Signataires"
                                              ]
                                            }
                                          </Tooltip>
                                        </th>
                                        <th
                                          className="text-nowrap"
                                          style={tableaustyles}
                                        >
                                          Actions
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {formSignature?.map((rowData) => (
                                        <tr key={rowData.index}>
                                          <td>
                                            <input
                                              className="form-control form-control-sm"
                                              style={{ minWidth: "50px" }}
                                              defaultValue={
                                                rowData.page_signature
                                              }
                                              name="page_signature"
                                              onChange={(e) =>
                                                handleInputChange(
                                                  rowData.index,
                                                  e.target.name,
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </td>
                                          <td>
                                            <input
                                              className="form-control form-control-sm"
                                              style={{ minWidth: "50px" }}
                                              defaultValue={
                                                rowData.position_signature
                                              }
                                              name="position_signature"
                                              onChange={(e) =>
                                                handleInputChange(
                                                  rowData.index,
                                                  e.target.name,
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </td>
                                          <td>
                                            <input
                                              className="form-control form-control-sm"
                                              style={{ minWidth: "50px" }}
                                              defaultValue={rowData.signataire}
                                              name="signataire"
                                              onChange={(e) =>
                                                handleInputChange(
                                                  rowData.index,
                                                  e.target.name,
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </td>
                                          <td>
                                            <i
                                              className="bx bx-trash"
                                              style={{
                                                fontSize: "20px",
                                                paddingTop: "5px",
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                onDeleteFormSignature(
                                                  rowData.index
                                                )
                                              }
                                            ></i>
                                          </td>
                                        </tr>
                                      ))}
                                      <tr>
                                        <td colSpan="3">
                                          <input
                                            type="button"
                                            style={tableaustyles}
                                            className="btn btn-info mt-3 mt-lg-0"
                                            value="Ajouter"
                                            onClick={onAddFormSignature}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default NewModel;
